import { useEffect, useState } from "react";
import image from "./restrictions.svg";
import { FormattedMessage } from "react-intl";
import {
  BottomButtonContainer,
  BottomButton,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import { MODULES } from "../../../../reduxStore/actions/main.js";
import ToggleSetting from "../../../elements/buttons/toggleSetting.component.jsx";
import StandardInstruction from "../../../elements/text/standardInstruction.component.jsx";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import IntroImage from "../../introImage.component.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main.js";

export default function Restrictions(props) {
  const [movementRestricted, setMovementRestricted] = useState(false);
  const [disabledParkingPermit, setDisabledParkingPermit] = useState(false);

  const handleButtonClicked = () => {
    props.setProperty("movementRestricted", movementRestricted);
    props.setProperty("disabledParkingPermit", disabledParkingPermit);
    nextPage();
  };

  const nextPage = () => {
    if (MODULES.hatPush && props.isApp) {
      props.history.push(
        `/${pageNames.intro}/${pageNames.selectPush}/${getQueryParams()}`
      );
    } else {
      props.history.push(
        `/${pageNames.intro}/${pageNames.complete}/${getQueryParams()}`
      );
    }
  };

  useEffect(() => {
    if (props.serverDataLoaded && MODULES && !MODULES.offerParkingDisabled)
      nextPage();
  }, [props.serverDataLoaded]);

  if (!MODULES || !MODULES.offerParkingDisabled) {
    return null;
  }

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          () => props.history.goBack(),
          <FormattedMessage id={"search.buttonBack"} />,
          { className: "mr-3 normalButton--naked" }
        ),
        new BottomButton(
          handleButtonClicked,
          <FormattedMessage id="welcome.next" />,
          { className: "normalButton--primary" }
        ),
      ]}
    >
      <IntroImage fallbackImage={image} imageName={"restrictions.svg"} />
      <div className="pl-3 pr-3">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.restrictionsTitle" />
        </StandardHeadline>
        <StandardInstruction className={"mb-4"} type={"p"}>
          <FormattedMessage id="welcome.restrictionsText" />
        </StandardInstruction>
        <ToggleSetting
          outerClassName={"mt-3"}
          settingText={
            <FormattedMessage id="welcome.restrictionsToggleMovementRestrictedText" />
          }
          toggleValue={movementRestricted}
          onChange={() => setMovementRestricted((prevState) => !prevState)}
        />
        <ToggleSetting
          outerClassName={"mt-3"}
          settingText={
            <FormattedMessage id="welcome.restrictionsToggleDisabledParkingPermitText" />
          }
          toggleValue={disabledParkingPermit}
          onChange={() => setDisabledParkingPermit((prevState) => !prevState)}
        />
      </div>
    </BottomButtonContainer>
  );
}
